import React, { useState } from 'react';
import Form from "react-bootstrap/Form";
import LoaderButton from "../components/LoaderButton";
import { onError } from "../libs/errorLib";
import "./PrivacyPolicy.css";

const PrivacyPolicyForm = ({setPage, setRefreshCount}) => {
  const [isAccepted, setIsAccepted] = useState(false);

  async function handleAcceptPolicy(event) {
    event.preventDefault();
      console.log("isAccepted = " + isAccepted);
      if (!isAccepted) {
          onError('内容を確認の上、「同意する」をチェックしてください。');
	  return false;
      }
      setPage('inputForm');
      setRefreshCount(100);
    return false;
  }

  return (
      <div id="registration" className="privacy">
        <div className="inner">
          <h2>日本臨床スポーツ医学会 個人情報保護について</h2>
          <p className="fWB">※お申込み前に、下記内容をご確認の上、同意ください。</p>
          <div>
「個人情報の保護に関する法律」に基づき、個人情報を以下のようにお取扱いし、保護に努めております。
予めこれらをご了承の上、個人情報をご提供いただけますようお願いいたします。
          </div>
          <h3>定義</h3>
          <p>個人情報とは、会員ならびに本学会の活動に関係する非会員の、氏名・生年月日などの特定の個人を識別できる情報を指します。</p>
          <h3>目的</h3>
          <dl>
            <dt>お預かりした個人情報は下記の目的で使用いたします。ご本人の承諾を得ない限り、下記の目的以外には使用いたしません。</dt>
            <dd>・「日本臨床スポーツ医学会」の運営</dd>
            <dd>・「日本臨床スポーツ医学会」に関するご連絡</dd>
            <dd>・「日本臨床スポーツ医学会」に関するご本人からのお問合せ対応や情報提供</dd>
          </dl>
          <h3>保護管理</h3>
          <p>ご本人からの、開示、内容の訂正、追加又は削除、利用目的の通知、利用の停止、消去及び第三者への提供の停止のお求めにはすみやかに対応いたします。</p>

          <h2>個人情報に関する連絡先</h2>
          <p>
           日本臨床スポーツ医学会 事務局<br/>
           〒104-0041 東京都中央区新富2-4-14 新富田所ビル4階<br/>
           一般社団法人 会議支援センター内<br/>
           TEL：03-6222-9874 FAX：03-6222-9875<br/>
           E-mail：rnsp@rinspo.jp<br/>
          </p>
          <p className="agreeActionLabel">上記の「個人情報の取扱いについて」に</p>
          <Form onSubmit={handleAcceptPolicy}>
            <Form.Group className="AcceptGroup" controlId="isAccepted" size="lg">
              <Form.Control
                autoFocus
                type="checkbox"
                checked={isAccepted}
                onChange={(e) => { console.log(e.target.checked); setIsAccepted(e.target.checked)}}
                value="1"
              />
              <Form.Label>同意します</Form.Label>
            </Form.Group>
            <LoaderButton
              block
              size="lg"
              type="submit"
              variant="success"
              isLoading={false}
              id="confirm"
              disabled={false}
            >
              次へ
            </LoaderButton>
          </Form>
        </div>
      {/* #registration */}
      </div> 
  );
}

export default PrivacyPolicyForm;
